
document.addEventListener('DOMContentLoaded', function () {
    
    // --- SCRIPT FOR CAROUSEL 1 ---
    (function() {
        const slidesContainer = document.getElementById('slides-container');
        if (!slidesContainer) return;

        // --- FIX: Find the parent container for *this* carousel ---
        // This stops the script from grabbing controls from other carousels.
        const container = slidesContainer.closest('.carousel-container');
        if (!container) {
            console.warn('Carousel 1: Could not find parent .carousel-container for #slides-container');
            return; // Exit if we can't find the main wrapper
        }
    
        const slides = slidesContainer.querySelectorAll('.slide');
        if (slides.length === 0) return; // Exit if no slides
    
        // --- FIXED: Select buttons *within this container only* ---
        const prevButtons = container.querySelectorAll('.prev-button');
        const nextButtons = container.querySelectorAll('.next-button');
    
        // --- FIXED: Select pills *within this container only* ---
        const progressPills = container.querySelectorAll('.progress-pill');
    
        let currentIndex = 0;
        const totalSlides = slides.length;
        let isDragging = false, startPos = 0, currentTranslate = 0, prevTranslate = 0, animationID;
    
        function updateCarousel(isSnapping = true) {
            // Safety check for slides
            if (!slides[0]) return;
            const slideWidth = slides[0].offsetWidth;
            if (slideWidth === 0) return; // Avoid dividing by zero if hidden
    
            const targetTranslate = -currentIndex * slideWidth;
            slidesContainer.style.transition = isSnapping ? 'transform 0.5s ease-in-out' : 'none';
            slidesContainer.style.transform = `translateX(${targetTranslate}px)`;
            prevTranslate = currentTranslate = targetTranslate;
    
            // Loop over ALL progress pills *in this container*
            progressPills.forEach(pill => {
                const progressBar = pill.parentElement;
                if (!progressBar) return; 
    
                const pillWidth = pill.offsetWidth;
                const progressBarWidth = progressBar.offsetWidth;
    
                if (progressBarWidth > 0) {
                    const travelDistance = progressBarWidth - pillWidth;
                    const positionOffset = (totalSlides > 1) ? (currentIndex / (totalSlides - 1)) * travelDistance : 0;
                    pill.style.left = `${positionOffset}px`;
                } else {
                    pill.style.left = '0px'; // Reset if hidden
                }
            });
    
            // Update Button States *in this container*
            prevButtons.forEach(button => {
                button.disabled = currentIndex === 0;
            });
            nextButtons.forEach(button => {
                button.disabled = currentIndex === totalSlides - 1;
            });
        }
        
        function getPositionX(event) { return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX; }
        
        function dragStart(event) { 
            if (!slides[0]) return;
            isDragging = true; 
            startPos = getPositionX(event); 
            slidesContainer.classList.add('grabbing'); 
            const slideWidth = slides[0].offsetWidth;
            prevTranslate = -currentIndex * slideWidth; 
            animationID = requestAnimationFrame(animation); 
        }
        
        function drag(event) { 
            if (isDragging) { 
                const currentPosition = getPositionX(event); 
                currentTranslate = prevTranslate + currentPosition - startPos; 
            } 
        }
        
        function dragEnd() { 
            if (!slides[0]) {
                isDragging = false;
                cancelAnimationFrame(animationID);
                return;
            }
            isDragging = false; 
            cancelAnimationFrame(animationID); 
            slidesContainer.classList.remove('grabbing'); 
            const movedBy = currentTranslate - prevTranslate; 
            const slideWidth = slides[0].offsetWidth; 
            if (slideWidth > 0) {
                if (movedBy < -slideWidth / 4 && currentIndex < totalSlides - 1) currentIndex++; 
                if (movedBy > slideWidth / 4 && currentIndex > 0) currentIndex--; 
            }
            updateCarousel(); 
        }
        
        function animation() { 
            if (isDragging) { 
                slidesContainer.style.transition = 'none'; 
                slidesContainer.style.transform = `translateX(${currentTranslate}px)`; 
                requestAnimationFrame(animation); 
            } 
        }
    
        nextButtons.forEach(button => {
            button.addEventListener('click', () => { 
                if (currentIndex < totalSlides - 1) { 
                    currentIndex++; 
                    updateCarousel(); 
                } 
            });
        });
    
        prevButtons.forEach(button => {
            button.addEventListener('click', () => { 
                if (currentIndex > 0) { 
                    currentIndex--; 
                    updateCarousel(); 
                } 
            });
        });
    
        slidesContainer.addEventListener('mousedown', dragStart);
        slidesContainer.addEventListener('mousemove', drag);
        slidesContainer.addEventListener('mouseup', dragEnd);
        slidesContainer.addEventListener('mouseleave', dragEnd);
        slidesContainer.addEventListener('touchstart', dragStart);
        slidesContainer.addEventListener('touchmove', drag);
        slidesContainer.addEventListener('touchend', dragEnd);
        
        // Use 'load' event to ensure images are rendered and widths are correct
        window.addEventListener('load', () => {
             updateCarousel(false);
        });
        
        window.addEventListener('resize', () => updateCarousel(false));
    })();

    // --- SCRIPT FOR CAROUSEL 2 ---
    (function() {
        // This script uses IDs, so it's already scoped.
        // It should now work fine since the first script is no longer interfering with it.
        const slidesContainer = document.getElementById('slides-container-alt');
        if (!slidesContainer) return;

        const slides = slidesContainer.querySelectorAll('.slide');
        if (!slides || slides.length === 0) return; // Check for slides

        const prevButton = document.getElementById('prev-button-alt');
        const nextButton = document.getElementById('next-button-alt');
        const progressPill = document.getElementById('progress-pill-alt');

        // Add safety checks in case elements are missing
        if (!prevButton || !nextButton || !progressPill) {
            console.warn('Carousel 2: Missing control elements (button or pill).');
            return;
        }

        const progressBar = progressPill.parentElement;
        if (!progressBar) {
            console.warn('Carousel 2: Progress pill has no parent element.');
            return;
        }

        let currentIndex = 0;
        const totalSlides = slides.length;
        let isDragging = false, startPos = 0, currentTranslate = 0, prevTranslate = 0, animationID;

        function updateCarousel(isSnapping = true) {
            if (!slides[0]) return; // Safety check
            const slideWidth = slides[0].offsetWidth;
            if (slideWidth === 0) return; // Avoid divide by zero

            const targetTranslate = -currentIndex * slideWidth;
            slidesContainer.style.transition = isSnapping ? 'transform 0.5s ease-in-out' : 'none';
            slidesContainer.style.transform = `translateX(${targetTranslate}px)`;
            prevTranslate = currentTranslate = targetTranslate;
            
            const pillWidth = progressPill.offsetWidth;
            const progressBarWidth = progressBar.offsetWidth;
            
            if(progressBarWidth > 0) {
                const travelDistance = progressBarWidth - pillWidth;
                const positionOffset = (totalSlides > 1) ? (currentIndex / (totalSlides - 1)) * travelDistance : 0;
                progressPill.style.left = `${positionOffset}px`;
            } else {
                progressPill.style.left = '0px';
            }

            prevButton.disabled = currentIndex === 0;
            nextButton.disabled = currentIndex === totalSlides - 1;
        }
        
        function getPositionX(event) { return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX; }
        
        function dragStart(event) { 
            if (!slides[0]) return;
            isDragging = true; 
            startPos = getPositionX(event); 
            slidesContainer.classList.add('grabbing'); 
            prevTranslate = -currentIndex * slides[0].offsetWidth; 
            animationID = requestAnimationFrame(animation); 
        }
        
        function drag(event) { 
            if (isDragging) { 
                const currentPosition = getPositionX(event); 
                currentTranslate = prevTranslate + currentPosition - startPos; 
            } 
        }
        
        function dragEnd() { 
            if (!slides[0]) {
                isDragging = false;
                cancelAnimationFrame(animationID);
                return;
            }
            isDragging = false; 
            cancelAnimationFrame(animationID); 
            slidesContainer.classList.remove('grabbing'); 
            const movedBy = currentTranslate - prevTranslate; 
            const slideWidth = slides[0].offsetWidth; 
            if (slideWidth > 0) {
                if (movedBy < -slideWidth / 4 && currentIndex < totalSlides - 1) currentIndex++; 
                if (movedBy > slideWidth / 4 && currentIndex > 0) currentIndex--; 
            }
            updateCarousel(); 
        }
        
        function animation() { 
            if (isDragging) { 
                slidesContainer.style.transition = 'none'; 
                slidesContainer.style.transform = `translateX(${currentTranslate}px)`; 
                requestAnimationFrame(animation); 
            } 
        }

        nextButton.addEventListener('click', () => { if (currentIndex < totalSlides - 1) { currentIndex++; updateCarousel(); } });
        prevButton.addEventListener('click', () => { if (currentIndex > 0) { currentIndex--; updateCarousel(); } });
        slidesContainer.addEventListener('mousedown', dragStart);
        slidesContainer.addEventListener('mousemove', drag);
        slidesContainer.addEventListener('mouseup', dragEnd);
        slidesContainer.addEventListener('mouseleave', dragEnd);
        slidesContainer.addEventListener('touchstart', dragStart);
        slidesContainer.addEventListener('touchmove', drag);
        slidesContainer.addEventListener('touchend', dragEnd);
        
        // Use 'load' instead of setTimeout for better reliability
        window.addEventListener('load', () => updateCarousel(false));
        window.addEventListener('resize', () => updateCarousel(false));
    })();

    // ---- Script to make change background sections work (Feature 1) --- // 
    (function() {
        const featureItems = document.querySelectorAll('.interactive-features__item');
        const backgroundDiv = document.getElementById('features-background');

        if (!backgroundDiv || featureItems.length === 0) return; // Exit if elements aren't here

        const defaultItem = document.querySelector('.interactive-features__item.active');
        if (defaultItem) {
            const defaultImage = defaultItem.getAttribute('data-image');
            if (defaultImage) {
                backgroundDiv.style.backgroundImage = `url('${defaultImage}')`;
            }
        }

        featureItems.forEach(item => {
            item.addEventListener('click', function() {
                featureItems.forEach(i => i.classList.remove('active'));
                this.classList.add('active');
                
                const imageUrl = this.getAttribute('data-image');
                if (imageUrl) {
                    backgroundDiv.style.backgroundImage = `url('${imageUrl}')`;
                }
            });
        });
    })();

    // ---- Script to make change background sections work (Feature 2) --- // 
    (function() {
        const featureItems = document.querySelectorAll('.interactive-features2__item');
        const backgroundDiv = document.getElementById('features-background2');

        if (!backgroundDiv || featureItems.length === 0) return; // Exit if elements aren't here

        const defaultItem = document.querySelector('.interactive-features2__item.active');
        if (defaultItem) {
            const defaultImage = defaultItem.getAttribute('data-image');
            if (defaultImage) {
                backgroundDiv.style.backgroundImage = `url('${defaultImage}')`;
            }
        }

        featureItems.forEach(item => {
            item.addEventListener('click', function() {
                featureItems.forEach(i => i.classList.remove('active'));
                this.classList.add('active');
                
                const imageUrl = this.getAttribute('data-image');
                if (imageUrl) {
                    backgroundDiv.style.backgroundImage = `url('${imageUrl}')`;
                }
            });
        });
    })();
    
});







        // ---- Script to make change background sections work --- // 

        document.addEventListener('DOMContentLoaded', function() {
            // Interactive Features Script
            const featureItems = document.querySelectorAll('.interactive-features__item');
            const backgroundDiv = document.getElementById('features-background');

            // Set the default background image on load
            const defaultItem = document.querySelector('.interactive-features__item.active');
            if (backgroundDiv && defaultItem) {
                const defaultImage = defaultItem.getAttribute('data-image');
                backgroundDiv.style.backgroundImage = `url('${defaultImage}')`;
            }

            featureItems.forEach(item => {
                // Changed event listener from 'mouseover' to 'click'
                item.addEventListener('click', function() {
                    // Remove 'active' class from all items
                    featureItems.forEach(i => i.classList.remove('active'));
                    // Add 'active' class to the clicked item
                    this.classList.add('active');
                    
                    // Change the background image
                    const imageUrl = this.getAttribute('data-image');
                    if (backgroundDiv) {
                        backgroundDiv.style.backgroundImage = `url('${imageUrl}')`;
                    }
                });
            });
        });

        document.addEventListener('DOMContentLoaded', function() {
            // Interactive Features Script
            const featureItems = document.querySelectorAll('.interactive-features2__item');
            const backgroundDiv = document.getElementById('features-background2');

            // Set the default background image on load
            const defaultItem = document.querySelector('.interactive-features2__item.active');
            if (backgroundDiv && defaultItem) {
                const defaultImage = defaultItem.getAttribute('data-image');
                backgroundDiv.style.backgroundImage = `url('${defaultImage}')`;
            }

            featureItems.forEach(item => {
                // Changed event listener from 'mouseover' to 'click'
                item.addEventListener('click', function() {
                    // Remove 'active' class from all items
                    featureItems.forEach(i => i.classList.remove('active'));
                    // Add 'active' class to the clicked item
                    this.classList.add('active');
                    
                    // Change the background image
                    const imageUrl = this.getAttribute('data-image');
                    if (backgroundDiv) {
                        backgroundDiv.style.backgroundImage = `url('${imageUrl}')`;
                    }
                });
            });
        });


        // --- Script for Pro Filter sections SP --- // 
document.addEventListener('DOMContentLoaded', () => {

            // --- DATA ---
            const pros = [
                { name: 'Scott Fletcher', title: 'PGA Professional', coachLevel: 'pga-professional', rating: 5.0, reviews: 140, price: 75, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/Scottyf.jpg?v=1770827964', location: 'Brentwood', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons', 'On-course-lessons' ], profileLink: '/pages/scott-fletcher-parz-pro' },
                { name: 'Sam Tawse', title: 'PGA Professional', coachLevel: 'pga-professional', rating: 5.0, reviews: 104, price: 65, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/STsquare.jpg', location: ['Brentwood'], lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons' ], profileLink: '/pages/sam-tawse-parz-pro' },
                { name: 'George Leversuch', title: 'PGA Assistant Professional', coachLevel: 'pga-assistant', rating: 4.9, reviews: 152, price: 55, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/george.jpg?v=1758896808', location: 'Wanstead', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons', 'On-course-lessons' ], profileLink: '/pages/george-leversuch-parz-pro' },
                { name: 'Lloyd Williams', title: 'PGA Professional', coachLevel: 'pga-professional', rating: 4.9, reviews: 152, price: 75, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBIMG_1450.webp?v=1774959242', location: 'Trent Park', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'On-course-lessons' ], profileLink: '/pages/lloyd-williams-parz-pro' },
                { name: 'Andrew Clarke', title: 'PGA Professional', coachLevel: 'pga-professional', rating: 5.0, reviews: 120, price: 65, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBAndrewPro.webp', location: 'Brentwood', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons' ], profileLink: '/pages/andrew-clarke-parz-pro' },
                { name: 'Curtis Knipes', title: 'PGA Tour Professional', coachLevel: 'pga-professional', rating: 4.9, reviews: 152,  img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/curtisprofile.jpg?v=1770828085', location: 'Not Allocated', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons', 'On-course-lessons' ], profileLink: '/pages/curtis-knipes-parz-pro' },
                { name: 'Ernie Grosvenor', title: 'PGA Professional', coachLevel: 'pga-professional', rating: 5.0, reviews: 98, price: 70, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBErnieProfile.webp', location: 'Brentwood', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons' ], profileLink: '/pages/ernie-grosvenor-parz-pro' },
                { name: 'Kish Velani', title: 'PGA Assistant Professional', coachLevel: 'pga-assistant', rating: 5.0, reviews: 210, price: 55, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/Kish.jpg?v=1758887330', location: 'Wanstead', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons', 'On-course-lessons' ], profileLink: '/pages/kish-velani-parz-pro' },
                { name: 'Jack Fisk', title: 'PGA Professional', coachLevel: 'pga-professional', rating: 4.8, reviews: 88, price: 50, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBJackFisk.webp', location: 'Brentwood', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons' ], profileLink: '/pages/jack-fisk-parz-pro' },
                { name: 'David Banks', title: 'PGA Professional', coachLevel: 'pga-professional', rating: 5.0, reviews: 120, price: 60, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBIMG_1457_copy.webp', location: 'Trent Park', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons' ], profileLink: '/pages/david-banks-parz-pro' },
                { name: 'David Hawkins', title: 'PGA Professional', coachLevel: 'pga-professional', rating: 5.0, reviews: 190, price: 85, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/DaveProfile.jpg?v=1770828312', location: 'Wanstead', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons', 'On-course-lessons' ], profileLink: '/pages/dave-hawkins-parz-pro' },
                { name: 'Adam Winwood', title: 'PGA Professional', coachLevel: 'pga-professional', rating: 4.9, reviews: 115, price: 70, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBadamwinwood.webp', location: 'Brentwood',lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons' ], profileLink: '/pages/adam-winwood-parz-pro' },
                { name: 'Karl Tighe', title: 'PGA Assistant Professional', coachLevel: 'pga-assistant', rating: 4.9, reviews: 115, price: 45, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/Karl2.jpg', location: 'WGC Bury',lessonTypes: ['Adult-Lessons',  'Junior-lessons' ], profileLink: '/pages/karl-tighe-parz-pro' },
                { name: 'Dale Whitnell', title: 'Tour Professional', coachLevel: 'pga-professional', rating: 4.9, reviews: 152,  price: 100, img: 'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/dale.jpg?v=1785147895', location: 'Not Allocated', lessonTypes: ['Adult-Lessons', 'studio-lesson', 'Junior-lessons', 'On-course-lessons' ], profileLink: '/pages/dale-whitnell-parz-pro' },
                ];

            // --- CONSTANTS ---
            const DISPLAY_LIMIT = 8;

            // --- DOM ELEMENTS ---
            const gridContainer = document.getElementById('grid-container');
            const grid = document.getElementById('pro-grid');
            const locationFilter = document.getElementById('location-filter');
            const lessonTypeFilter = document.getElementById('lesson-type-filter');
            const coachLevelFilter = document.getElementById('coach-level-filter');
            const loadMoreBtn = document.getElementById('load-more-btn');

            // --- FUNCTIONS ---
            
            // Randomize function (Fisher-Yates)
            function shuffleArray(array) {
                for (let i = array.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [array[i], array[j]] = [array[j], array[i]];
                }
            }

            function renderGrid(prosToRender) {
                grid.innerHTML = '';
                if (prosToRender.length === 0) {
                    grid.innerHTML = `<p style="grid-column: 1 / -1; text-align: center; color: #9CA3AF;">No professionals match the current filters.</p>`;
                    return;
                }
                prosToRender.forEach(pro => {
                    const card = document.createElement('div');
                    card.className = 'card';
                    card.innerHTML = `
                        <img src="${pro.img}" alt="${pro.name}" class="card-image" onerror="this.onerror=null;this.src='https://placehold.co/400x400/000000/FFFFFF?text=Image+Not+Found';">
                        <div class="card-content">
                            <h3 class="card-title">${pro.name}</h3>
                            <p class="card-subtitle">${pro.title}</p>
                            <div class="card-footer">
                                <div class="card-meta-group">
                                    <span class="card-meta-item">
                                        <svg class="card-rating-icon" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                                        ${pro.rating.toFixed(1)} (${pro.reviews})
                                    </span>
                                    <span class="card-price"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; margin-top: -2px;">
<circle cx="8" cy="8" r="7.5" stroke="black"/>
<path d="M5.18544 11.7998V10.8998C5.49744 10.5878 5.73744 10.2678 5.90544 9.9398C6.07344 9.6038 6.15744 9.1718 6.15744 8.6438C6.15744 8.5078 6.14544 8.3678 6.12144 8.2238H4.75344V7.1678H5.78544C5.71344 6.9598 5.64944 6.7438 5.59344 6.5198C5.54544 6.2958 5.52144 6.0598 5.52144 5.8118C5.52144 5.2838 5.63344 4.8278 5.85744 4.4438C6.08944 4.0598 6.40944 3.7678 6.81744 3.5678C7.23344 3.3598 7.70944 3.2558 8.24544 3.2558C8.85344 3.2558 9.35744 3.3718 9.75744 3.6038C10.1574 3.8358 10.4614 4.1478 10.6694 4.5398C10.8774 4.9318 10.9934 5.3678 11.0174 5.8478H9.60144C9.58544 5.4718 9.46544 5.1598 9.24144 4.9118C9.01744 4.6558 8.69344 4.5278 8.26944 4.5278C7.91744 4.5278 7.61344 4.6358 7.35744 4.8518C7.10144 5.0678 6.97344 5.4038 6.97344 5.8598C6.97344 6.0678 7.00544 6.2838 7.06944 6.5078C7.13344 6.7238 7.20544 6.9438 7.28544 7.1678H9.52944V8.2238H7.57344C7.59744 8.3678 7.60944 8.5078 7.60944 8.6438C7.60944 8.9718 7.54544 9.3038 7.41744 9.6398C7.28944 9.9758 7.07744 10.2878 6.78144 10.5758H11.0534V11.7998H5.18544Z" fill="black"/>
</svg>
 £${pro.price}/hour</span>
                                </div>
                                <a href="${pro.profileLink}"  class="card-action-button">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M-6.11959e-07 9L12.17 9L6.58 14.59L8 16L16 8L8 6.99382e-07L6.59 1.41L12.17 7L-7.86805e-07 7L-6.11959e-07 9Z" fill="currentcolor"/>
</svg>
  </a>
                            </div>
                        </div>
                    `;
                    grid.appendChild(card);
                });
            }

            function applyFilters() {
                const location = locationFilter.value;
                const lessonType = lessonTypeFilter.value;
                const coachLevel = coachLevelFilter.value;

                const filteredPros = pros.filter(pro => {
                    const locationMatch = location === 'all' || pro.location === location;
                    const lessonTypeMatch = lessonType === 'all' || pro.lessonTypes.includes(lessonType);
                    const coachLevelMatch = coachLevel === 'all' || pro.coachLevel === coachLevel;
                    
                    return locationMatch && lessonTypeMatch && coachLevelMatch;
                });

                renderGrid(filteredPros);

                if (filteredPros.length > DISPLAY_LIMIT) {
                    grid.classList.add('collapsed');
                    gridContainer.classList.add('faded');
                    loadMoreBtn.style.display = 'block';
                } else {
                    grid.classList.remove('collapsed');
                    gridContainer.classList.remove('faded');
                    loadMoreBtn.style.display = 'none';
                }
            }

            // --- EVENT LISTENERS ---
            locationFilter.addEventListener('change', applyFilters);
            lessonTypeFilter.addEventListener('change', applyFilters);
            coachLevelFilter.addEventListener('change', applyFilters);
            loadMoreBtn.addEventListener('click', () => {
                grid.classList.remove('collapsed');
                gridContainer.classList.remove('faded');
                loadMoreBtn.style.display = 'none';
            });

            // --- INITIAL RENDER ---
            shuffleArray(pros); // Randomize the list once on load
            applyFilters();     // Then apply filters and render
        });


        //---- script for pro testimonial tab ---//

         document.addEventListener('DOMContentLoaded', function () {
            const container = document.getElementById('component-container');
            const tabSelectorsContainer = document.getElementById('tab-selectors');
            const tabSelectors = document.querySelectorAll('.tab-selector');
            const tabContentContainer = document.getElementById('tab-content');
            const tabPanes = document.querySelectorAll('.tab-pane');
            const slidingBorder = document.getElementById('sliding-border');
            
            let currentView = '';

            function updateBorderPosition() {
                const activeTab = document.querySelector('.tab-selector.active');
                if (!activeTab || currentView === 'mobile') return;

                const containerRect = tabSelectorsContainer.getBoundingClientRect();
                const activeTabRect = activeTab.getBoundingClientRect();
                const activeTabId = activeTab.getAttribute('data-tab');
                let borderWidth;

                switch (activeTabId) {
                    case 'pro-1': borderWidth = activeTabRect.width * 0.3; break;
                    case 'pro-2': borderWidth = activeTabRect.width * 0.6; break;
                    case 'pro-3': borderWidth = activeTabRect.width; break;
                    default: borderWidth = activeTabRect.width;
                }
                
                const paddingOffset = (containerRect.width - (activeTabRect.width * 3 + (containerRect.width - activeTabRect.width * 3) / 2 * 2)) / 2;
                
                slidingBorder.style.width = `${borderWidth}px`;
                slidingBorder.style.transform = `translateX(${activeTabRect.left - containerRect.left - paddingOffset}px)`;
            }

            function activateTab(activeSelector, activePane) {
                tabSelectors.forEach(s => s.classList.remove('active'));
                tabPanes.forEach(p => p.classList.remove('active'));
                activeSelector.classList.add('active');
                activePane.classList.add('active');
                updateBorderPosition();
            }

            function toggleAccordion(selector, pane) {
                const isActive = selector.classList.contains('active');
                tabSelectors.forEach(s => s.classList.remove('active'));
                tabPanes.forEach(p => p.classList.remove('active'));
                if (!isActive) {
                    selector.classList.add('active');
                    pane.classList.add('active');
                }
            }
            
            function setupDesktopView() {
                container.classList.remove('mobile-view');
                container.classList.add('desktop-view');
                // Move panes back to the main content container
                tabPanes.forEach(pane => tabContentContainer.appendChild(pane));
                activateTab(tabSelectors[0], document.getElementById(tabSelectors[0].dataset.tab));
            }

            function setupMobileView() {
                container.classList.remove('desktop-view');
                container.classList.add('mobile-view');
                // Move each pane to be after its corresponding selector
                tabSelectors.forEach(selector => {
                    const pane = document.getElementById(selector.dataset.tab);
                    selector.after(pane);
                });
                toggleAccordion(tabSelectors[0], document.getElementById(tabSelectors[0].dataset.tab));
            }

            function switchView() {
                const newView = window.innerWidth < 768 ? 'mobile' : 'desktop';
                if (newView !== currentView) {
                    currentView = newView;
                    if (currentView === 'mobile') {
                        setupMobileView();
                    } else {
                        setupDesktopView();
                    }
                }
            }

            tabSelectorsContainer.addEventListener('click', function (e) {
                const clickedTab = e.target.closest('.tab-selector');
                if (!clickedTab) return;
                const pane = document.getElementById(clickedTab.dataset.tab);
                if (currentView === 'mobile') {
                    toggleAccordion(clickedTab, pane);
                } else {
                    activateTab(clickedTab, pane);
                }
            });

            window.addEventListener('resize', () => {
                switchView();
                // Debounced border update on resize for desktop
                setTimeout(updateBorderPosition, 100);
            });

            // Initial Setup
            switchView();
        });



        // PRO SECTION SELECT SERVICE
// Wait for the document to be fully loaded before running the script
document.addEventListener('DOMContentLoaded', () => {

    const scrollButtons = document.querySelectorAll('.scroll-button');
    const allSections = document.querySelectorAll('.hidden-section');

    // Store the original text of each button in a data attribute for later use
    scrollButtons.forEach(button => {
        button.dataset.originalText = button.textContent;
    });

    scrollButtons.forEach(clickedButton => {
        clickedButton.addEventListener('click', () => {
            
            const targetSelector = clickedButton.dataset.target;
            const targetElement = document.querySelector(targetSelector);
            
            // Check if the button clicked is already active
            const isAlreadyActive = clickedButton.classList.contains('active');

            // --- First, reset all buttons and hide all sections ---
            allSections.forEach(section => {
                section.style.display = 'none';
            });

            scrollButtons.forEach(btn => {
                btn.classList.remove('active'); // Remove active class from all buttons
                btn.textContent = btn.dataset.originalText; // Reset text for all buttons
            });

            // --- Then, handle the clicked button ---
            // If it wasn't already active, we make it active and show its section
            if (!isAlreadyActive && targetElement) {
                
                // Activate the clicked button
                clickedButton.classList.add('active');
                const sectionNumber = targetSelector.replace('#section', '');
                clickedButton.textContent = `Packages Available Below`; // Change text
                
                // Show its section
                targetElement.style.display = 'block';

                // Scroll to its section
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start' // ✅ THIS IS THE ONLY CHANGE
                });
            }
        });
    });
});


// Pro Page Tabs
        // Get the containers for buttons and content
        const tabButtonsContainer = document.getElementById('tab-buttons');
        const tabContentsContainer = document.getElementById('tab-contents');

        // Get all buttons and content panels
        const tabs = tabButtonsContainer.querySelectorAll('.tab-btn');
        const contents = tabContentsContainer.querySelectorAll('.tab-content-pro');

        // Add a click event listener to the button container (using event delegation)
        tabButtonsContainer.addEventListener('click', (event) => {
            const clickedTab = event.target.closest('.tab-btn');
            
            // If the click was not on a button, do nothing
            if (!clickedTab) return;

            // Get the target tab ID from the data-tab attribute
            const targetId = clickedTab.dataset.tab;
            const targetContent = document.getElementById(targetId);

            // Remove 'active' class from all tabs and content panels
            tabs.forEach(tab => tab.classList.remove('active'));
            contents.forEach(content => content.classList.remove('active'));

            // Add 'active' class to the clicked tab and its corresponding content
            clickedTab.classList.add('active');
            if (targetContent) {
                targetContent.classList.add('active');
            }
        });

        window.addEventListener('message', function(event) {
  if (
    event.origin === 'https://nearlynewgolfclubs.co.uk' &&
    event.data &&
    event.data.type === 'navigate' &&
    event.data.url
  ) {
    window.location.href = event.data.url;
  }
});


// Find every booking block on the page
const bookingContainers = document.querySelectorAll('.booking-form-inline');

bookingContainers.forEach(container => {
  // Find the select and the target specifically inside THIS container
  const selector = container.querySelector('.participant-select');
  const target = container.querySelector('.button-target');

  function updateButton() {
    const selectedValue = selector.value;
    const selectedText = selector.options[selector.selectedIndex].text;

    if (selectedValue) {
      target.innerHTML = `
        <div class="custom-booking-wrapper" section_id="ecom-as1v08s80g">
          <a href="${selectedValue}" 
             class="my-custom-btn" 
             bookeasy-listener="true">
            <span>Book for ${selectedText}</span>
          </a>
        </div>
      `;
    }
  }

  // Listen for changes on this specific dropdown
  selector.addEventListener('change', updateButton);

  // Initialize this specific button immediately
  updateButton();
});



// Menu Book Script
